import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingButtonComponent } from './loading-button.component';
import { SharedModules } from '../../shared.modules';

@NgModule({
  declarations: [LoadingButtonComponent],
  imports: [
    CommonModule,
    SharedModules
  ],
  exports:[LoadingButtonComponent]
})
export class LoadingButtonModule { }
